import { json_headers, request } from './common';

const basePath = () => `${window.configs.API_HOST}/api/connections/derbysoft`;

export const detectMissingProducts = (propertyId: string): Promise<{ status: number; message: string }> => {
  return request(`${basePath()}/detect-missing-products/${propertyId}`, {
    method: 'POST',
    headers: json_headers,
  });
};
